import { cn } from "@/lib/utils";

interface AudioIndicatorProps {
  isActive: boolean;
  className?: string;
}

export const AudioIndicator = ({ isActive, className }: AudioIndicatorProps) => {
  return (
    <div className={cn("barca-chat-audio-indicator bw-relative bw-flex bw-items-center bw-justify-center", className)}>
      {/* Main circle with slow animation */}
      <div
        className={cn(
          "bw-w-4 bw-h-4 bw-rounded-full bw-transition-all bw-duration-500",
          isActive ? "bw-bg-accent/30 barca-chat-slow-audio-pulse" : "bg-muted"
        )}
      />

      {/* Single ripple effect when active */}
      {isActive && (
        <div className="bw-absolute bw-w-4 bw-h-4 bw-rounded-full bw-bg-accent/30 barca-chat-slow-audio-ripple" />
      )}
    </div>
  );
};
